<template>
  <v-app style="margin-top:0px;" >
      <v-card flat v-bind:style="{ 'background-image': 'linear-gradient(to bottom,rgba(243, 177, 55, 0.73), rgba(58, 18, 18, 0.73)), url(' + banner + ')' }" class="tst">
          <v-container>
              <h1 style="margin-top:20px;">{{ countryName }}</h1>
          </v-container>
      </v-card>
<div class="container con" >
      <div class="row" style="margin-top:-100px; " >
        <div class="col-lg-9 col-md-9 col-sm-12" >
      <v-card flat style="border: 1px solid #b6b6b6;">
      <v-container>
          <div class="row" style="padding-top:20px;padding-left:15px;padding-right:15px;">
            <h2 class="country-heading m-2 " >WHY STUDY ABROAD IN {{ countryName }}</h2>
            <img :src="image" style="width: 50%;height:300px;" />
          <div class="col-lg-12 col-md-12 col-sm-12" style="color:grey;margin-top:50px;text-align: justify;">
            <h3 class="country-heading"><strong>Introduction</strong></h3>
            <p>The United States of America (U.S.A. or USA), sometimes referred to as the United States (U.S. or US) or America, is a nation with its main territory being in North America. It is made up of 326 Indian reservations, five significant unincorporated territories, nine Minor Outlying Islands, and 50 states. The United States is the third-largest country in the world in terms of both land area and total area. It has maritime boundaries with the Bahamas, Cuba, Russia, and other the most populated nation in the Americas and the third most populous in the world, with a population of over 333 million. Washington, D.C., serves as the nation's capital and as one of countries, as well as shared land borders with Canada to the north and Mexico to the south. New York metropolis is a large metropolis and a major financial hub.</p>
            <h3 class="country-heading"><strong>Why to study in USA?</strong></h3>
            <p>In STEM programs, US institutions have carved out a special place for themselves. International students favor the United States above other choices when wanting to pursue higher education in STEM fields. Additionally, premier institutions in the US are available to individuals wishing to enroll in business, management, or arts courses as well as STEM courses.</p>
            <p>There are several good reasons why Americans opt to study in the United States. Numerous variables, ranging from cultural to economic, contribute to the appeal of studying in the United States for students. Here are some reasons why prospective students ought to think about attending American institutions and colleges:</p>
             <ol>
              <li><strong>Academic Excellence:</strong> For many years, US colleges have been rated as the best in the world. American universities have gained acclaim for upholding the best academic standards by surpassing institutions from the UK, Canada, Australia, and India. The greatest intellectual talent flocks to US colleges as a result of this academic brilliance. Universities include Stanford University, New York University, the Massachusetts Institute of Technology (MIT), and many other top universities in the world.</li>
              <li><strong>Diverse Student Body:</strong> Students from many cultures and nations study in the United States. On an average day, one may find students on the college campus from at least 10 to 15 different nations. Indian students might consider studying in the USA if they wish to interact with individuals from other cultures and create new acquaintances.</li>
              <li><strong>Diverse Program Offerings</strong> Universities in the USA provide a selection of outstanding programs and courses in addition to the diversity of their fellow students. US institutions provide a wide choice of speciality degrees, whether at the undergraduate or master's level.</li>
              <li><strong>Institutional Diversity</strong> America's institutions provide variety on every conceivable level. Students experience another degree of diversity during their study, in addition to the diversity of students and the variety of programs: the diversity of institutions. The first two years of the bachelor's degree can be finished by students in a community college. They can transfer their qualifications to a university after the two years are up. A community college education has the advantages of reduced tuition fees, more individualized instruction, and a deeper appreciation of American culture. Students also have the option of enrolling in a four-year institution or university.</li>
              <li><strong>Institutional Diversification</strong> America's institutions provide variety on every conceivable level. Students experience another degree of diversity during their study, in addition to the diversity of students and the variety of programs: the diversity of institutions. The first two years of the bachelor's degree can be finished by students in a community college. They can transfer their qualifications to a university after the two years are up. A community college education has the advantages of reduced tuition fees, more individualized instruction, and a deeper appreciation of American culture. Students also have the option of enrolling in a four-year institution or university. They can study at a major university if they wish to experience campus life at its finest.</li>
              <li><strong>The Advantages of Tech</strong> The fact that the United States is one of the world's technological leaders is widely acknowledged. The best research equipment is made possible by advanced technologies. A student can take use of the technology without taking a science or engineering course. These top tech tools and resources can assist students in performing research and processing information, whether they are studying the social sciences, the arts, or some branches of technology.</li>
              <li><strong>Unparalleled Research Scope</strong> American colleges generate the most research papers each year when measured in terms of how many students they have. The excellent academic standards of US institutions are not the only reason for this high number. Yes, a high-quality education is a major factor, but America also heavily invests in several research initiatives in higher education. Indian students have unrivaled research opportunities because to funding. Better time, space, infrastructure, and technology, in addition to financial support, greatly expand the potential for ground-breaking research.</li>
             </ol>

            <h4 class="country-heading"><strong>Student Visa Process in USA</strong></h4>
             <p class="country-heading"><strong>Required documents for student passport visa:</strong></p>
             <p>For your US Student Visa application to US institutions, you will typically require the following:</p>
             <ul>
              <li>A passport that is current and has at least six months left on its validity term.</li>
              <li>A current passport-sized picture.</li>
              <li>DS-160 confirmation page.</li>
              <li>Form I -20.</li>
              <li>SEVIS application costs must be paid.</li>
              <li>Filing a non-immigrant application.</li>
              <li>If there are any extra criteria, your university will inform you prior to your application.</li>
             </ul>
             <h4 class="country-heading"><strong>HOW TO APPLY</strong></h4>
             <p><strong>Step 1:</strong>Submit an application to a US institution and be accepted. <br> Applying to (and ultimately being accepted into) a US institution is the first step. Most full-time undergraduate and graduate schools in the United States need applications by December or January of each year. Notices of admission are typically delivered in March and April.</p>
             <p><strong>Step 2:</strong>Obtain the Form I-20 or DS-2019 from your school. <br> One of two documents—Form I-20 (Certificate of Eligibility for Nonimmigrant Student Status) for F-1 and M-1 students and Form DS-2019 (Certificate of Eligibility for Exchange Visitor (J-1) Status) for J-1 students—will be sent to you after you've been admitted to a school. </p>
             <p><strong>Step 3:</strong>Pay the SEVIS I-901 charge in step three. <br> Once you get your I-901 SEVIS charge, go online and pay it. receiving your DS-2019 or I-20 from your school. Once more, the cost is 350 USD for F-1/M-1 students and 220 USD for J-1 students. Only $35 USD will be required from those with short-term J-1 visa programs.</p>
             <p><strong>Step 4:</strong>Find a US Embassy or Consulate in Your Area in You must submit an application for an international student visa at the US embassy or consulate that is closest to you (preferably, in the area where you now reside). A search for US embassies and consulates may be done online through the US Department of State. <br>Please be aware that the procedure for getting an American student visa may differ significantly depending on which embassy you apply through.</p>
             <p><strong>Step 5:</strong>Online DS-160 form completion. <br> After that, complete Form DS-160, online Non-Immigrant Visa Application. <br> On this application, you will also choose the US embassy where you will have your visa interview.</p>
             <p><strong>Step 6:</strong>Make an appointment for your visa interview. <br> After submitting Form DS-160, get in touch with the closest US embassy or consulate (ideally the one you specified on your online application) to arrange your visa interview.</p>
             <p><strong>Step 7:</strong>Pay the application cost for your visa. <br> After that, pay the 160 USD application cost. No matter where you apply or where you are from, this fee is the same. <br> It's crucial to keep in mind that depending on your embassy, the precise date you pay this payment will change.</p>
             <p><strong>Step 8:</strong>Show up for your visa interview. <br> The visa application process's last significant phase is the interview. Your ability to study in the United States will depend on the outcome of this interview.</p>
             <p><strong>Step 9:</strong>Pay the cost for issuing the visa. <br> Certain students must pay a visa issuance fee after being granted permission to get a student visa for the United States. Your nationality and the reciprocity agreement your country has with the United States will decide whether or not you have to pay this charge. If you want to know if you have to pay a visa issue fee, you can consult a chart on the US visas website.</p>
             <p><strong>Step 10:</strong>Apply for a visa <br> If you've met all of the criteria above and been granted an international student visa to the United States, your embassy will give your passport back to you together with your new visa. It's important to note that although some embassies may ask you to pick it up personally, others will send it back to you by shipping.</p>
             <p>The processing period for your visa varies depending on the embassy.</p>

             <h4 class="country-heading"><strong>Educational System</strong></h4>
             <p>In the USA, students who have completed high school (12th standard) enroll in colleges and universities to pursue higher education. International students have access to a wealth of options in the American educational system. In the USA, there are around 4,500 authorized higher education institutions that provide three different sorts of degrees:</p>
             <p>Undergraduate Degree: In the USA, an undergraduate degree that is completed full-time is known as a bachelor's degree. The degree takes four years to complete.</p>
             <p>Associate degrees are earned while pursuing undergraduate studies. It is provided by community colleges in the USA and is comparable to a diploma. It lasts for two years.</p>
             <p>Graduate Degree: In American colleges, a graduate or master's degree typically takes two to three academic years to complete.</p>
             <p>Doctoral Degree: It takes 5 to 8 years to earn a doctoral degree.</p>
             <p class="country-heading">Below is a full overview of the many higher education institution kinds in the USA:</p>

             <div class="body table-responsive">
                    <table class="table table-bordered" style="margin-top: 10px;">
                        <thead>
                          <tr style="background-color: #f48d8d;">
                            <th style="text-align: center;">Types of Institute</th>
                            <th style="text-align: center;">47(Times Higher Education ranking)</th>
                         
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td >State College or Universities</td>
                            <td>subsidized by the federal, state, or municipal government</td>
                          </tr>
                          <tr>
                            <td >Private College or Universities</td>
                            <td>run by private organizations or groups</td>
                          </tr>
                          <tr>
                            <td >Community College</td>
                            <td>2 year associate degrees or certifications are available.</td>
                          </tr>
                          <tr>
                            <td >Institute of technology</td>
                            <td>Provides graduate and short-term scientific and technology programs.</td>
                          </tr>
                        </tbody>
                      </table>
          </div>
          <h4 class="country-heading"><strong>American credit system</strong></h4>
          <p>Students from India and other countries can apply online to study in the United States. The following is a step-by-step approach on how to study in the United States:</p>
          <p>Choose the course you wish to take, and then look for the top institutions that offer it.</p>
          <p>Once the institutions have been narrowed down, look up the prerequisites and eligibility requirements on each university's official website.</p>
          <p>The application procedure should begin. Complete the application form and upload all necessary paperwork. Pay the application fee that is necessary.</p>
          <p>Await the return of the universities. You will receive an I-20 form after you have been chosen. You require it in order to obtain your student visa. Application Procedure.</p>
          <p>Admission Criteria:</p>
          <p>There is a process to pursue higher study in USA. Students have to have certain eligibility criteria before getting entered to any university. Such academic criteria are given below:</p>

          <div class="body table-responsive">
                    <table class="table table-bordered" style="margin-top: 10px;">
                        <thead>
                          <tr style="background-color: #f48d8d;">
                            <th style="text-align: center;">Degree available</th>
                            <th style="text-align: center;">Academic criteria</th>
                         
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="text-align: center;" >Associate Degree</td>
                            <td>High School Transcript or equivalent with an average of C grade</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;">Bachelor’s Degree</td>
                            <td>Certificate from the 12th grade with a minimum GPA of 2.50 to 3.60 TOEFL - 61 SOP ACT/SAT</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;" >Master’s Degree</td>
                            <td>A bachelor's degree with a minimum GPA of 2.50 to 3.60 and a TOEFL score of 78 to 100 is required.</td>
                          </tr>

                        </tbody>
                      </table>
          </div>
                       
          <p class="country-heading">Student fees</p>
          <p>The university you select and the program you enroll in will determine the tuition cost in the USA. Your costs are significantly reduced if you can enroll in one of the public colleges in the USA. In contrast, private institutions in the USA have higher tuition costs than do public universities.</p>
          <div class="body table-responsive">
                    <table class="table table-bordered" style="margin-top: 10px;">
                        <thead>
                          <tr style="background-color: #f48d8d;">
                            <th style="text-align: center;">Programmee</th>
                            <th style="text-align: center;">Fees(Average Annual Fees)</th>
                         
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="text-align: center;" >Bachelor’s programme</td>
                            <td style="text-align: center;">$8,000-$40,000</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;">Master’s Programme</td>
                            <td style="text-align: center;">$10000-$60000</td>
                          </tr>

                        </tbody>
                      </table>
          </div>

          <p class="country-heading">Living expenses</p>
            <p>Again, the sort of lifestyle you select will determine the cost of living in the United States for international students. You must choose student housing if your budget is limited. Additionally, there are some expenses that must be avoided. The following is a breakdown of the typical cost of living in the USA for overseas students:</p>


            <div class="body table-responsive">
                    <table class="table table-bordered" style="margin-top: 10px;">
                        <thead>
                          <tr style="background-color: #f48d8d;">
                            <th style="text-align: center;">Particular Living Expense</th>
                            <th style="text-align: center;">Average cost per year</th>
                         
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="text-align: center;" >Rent Allowance</td>
                            <td style="text-align: center;">$21710</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;">Food Allowance</td>
                            <td style="text-align: center;">$8,500</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;">Dormitory Housing</td>
                            <td style="text-align: center;">$7558-$11,914</td>
                          </tr> 
                           <tr>
                            <td style="text-align: center;">Transportation</td>
                            <td style="text-align: center;">$2180</td>
                          </tr>                         
                           <tr>
                            <td style="text-align: center;">Books and Supplies</td>
                            <td style="text-align: center;">$13,800</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;">Miscellaneous</td>
                            <td style="text-align: center;">$1000</td>
                          </tr>
                        </tbody>
                      </table>
          </div>
          <h4 class="country-heading"><strong>Visa</strong></h4>
          <p>Indian students can study in the US with a relatively easy visa application process. To obtain your visa without any problems, you must carefully follow all the instructions. Following is a step-by-step approach for applying for a student visa for the United States: </p>
          <p>Apply to and get accepted by a US school participating in the Student and Exchange Visitor Program (SEVP) six to twelve months before you want to study there.</p>
          <p>You will be sent an I-20 or DS-160 form after being admitted to a school with SEVP certification. To apply for a student visa to the USA, the form is required.</p>
          <p>At least three days before submitting your US visa application, pay your SEVIS fee. You have two options for making the payment: online or on paper. On the official US Immigration Customs Enforcement (ICE) SEVP website, you may find out more about them.</p>
          <p>You can schedule an appointment with a US consulate or embassy in your country to apply for a US student visa after receiving your SEVIS form and paying the SEVIS fee.</p>
          <p>Pay the application cost for a visa. It is often referred to as the "MRV fee," or Machine Readable Visa charge.</p>
          <p>Setting up and attending a US student visa interview is the last stage. Check the website of the embassy or consulate to see what documentation is necessary to provide at the interview. You must always submit the DS-160 visa application form in an online format. Make your choice as to where you want to apply, and make sure you have all the information and papers needed for the application form.</p>
 
          <h4 class="country-heading">Required paperwork and personal information for DS-160 visa applications:</h4>
          <p>Name and birthdates</p>
          <p>Addresses and telephone numbers</p>
          <p>Passport information</p>
          <p>Information about the itinerary and the passengers</p>
          <p>Information on prior US trip</p>
          <p>Your American point of contact</p>
          <p>Details about your family, job, and education</p>
          <p>Background, security, and health information</p>
          <p>SEVIS ID and the US school or program's address (as indicated on the I-20 or DS-2019 form) that you wish to enroll in. </p>
          <h4 class="country-heading">Work permits and permanent residence in the USA:</h4>
          <p>Students are permitted to remain in the nation after their F1 student visa extension expires with the acquisition of an H-1B USA work visa. Students can stay and work in the US for up to 6 years with this visa. </p>
          <p>For permanent residency in the US, students who want to stay for more than six years may apply for a green card. The following are some methods for F1 students to apply for a green card in the USA:</p>
          <p>Get company sponsorship</p>
          <p>Marry a US national</p>
          <p>Demand asylum</p>
          <p>Service in the armed forces</p>
          <p>Obtain parental or juvenile sponsorship</p>
          <p>Students who meet any of the aforementioned requirements will undoubtedly receive their PR in the USA. In the USA, having a PR enables people to apply for all kind of job opportunities in USA.</p>
          <h4 class="country-heading">Career Opportunities:</h4>
          <p>International students can choose to work part-time in the USA if they have a student visa. </p>
          <p>The US government enforces a 20-hour work-week limit for overseas students doing part-time employment there. </p>
          <p>Student employment comes in two flavors: on-campus and off-campus. The former refers to work done on a college or university campus. On the other hand, institution-affiliated labor is done off-campus. Students may work off-campus in one of four categories: International Organizations, Optional Practice Training (OPT), and Curricular Practical Training (CPT).</p>
          <h4 class="country-heading">Options for Post-Study Employment for International Students in the USA</h4>
          <p>The majority of foreign students studying in the US have an F-1 non-immigrant student visa. Depending on the degree, having an F1 visa allows them to work in the USA once their studies are complete. However, the United States Citizenship and Immigration Service (USCIS) has set certain recommendations and limitations in this respect. </p>

          <div class="body table-responsive">
                    <table class="table table-bordered" style="margin-top: 10px;">
                        <thead>
                          <tr style="background-color: #f48d8d;">
                            <th style="text-align: center;">Area of Specialization</th>
                            <th style="text-align: center;">Salary Level</th>
                         
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="text-align: center;" >Management</td>
                            <td style="text-align: center;">$144830</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;">Computer Science</td>
                            <td style="text-align: center;">$126,830</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;">Chemical Engineering</td>
                            <td style="text-align: center;">$108540</td>
                          </tr> 
                           <tr>
                            <td style="text-align: center;">Statistics/data science</td>
                            <td style="text-align: center;">$103930</td>
                          </tr>                         
                           <tr>
                            <td style="text-align: center;">Electrical and Electronic Engineering</td>
                            <td style="text-align: center;">$100830</td>
                          </tr>
                        </tbody>
                      </table>
          </div>




           
          </div>     
        </div>
        </v-container>
    </v-card>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6;">
                  <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Interested in studying abroad?</h3>
                  </div>
                  <v-container v-if="otp==false">
                      <v-form ref="form" v-model="valid" lazy-validation>
                          <v-layout row wrap >
                              <v-flex xs12 style="padding-top:10px;" >
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;" v-model="form.name" label="Full Name *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCountry"
                                   :items="countries"
                                   color="primary"
                                   label="Preferred Country *"
                                   item-text="countryName"
                                   item-value="countryName"

                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCourse"
                                   :items="courses"
                                   color="primary"
                                   label="Preferred Course *"
                                   item-text="courses"
                                   item-value="courses"
                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave" large block dark color="primary" @click="getOtp()">Send Message</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>

                  <v-container v-if="otp==true">
                      <v-form ref="form1" v-model="valid" lazy-validation>
                          <v-layout row wrap>
                              <v-flex xs12>
                                  <label>Enter Your OTP here *</label>
                                  <v-text-field outline style="background-color:white;height:56px" v-model="form1.pin" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave1" large block dark color="primary" @click="onSubmit()">Vefity Now</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>
          </v-card>
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6; margin-top: 10px;">
            <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Universities</h3>
                  </div>
             <marquee direction="up" scrollamount="3" style="margin-top:20px;height:150px ; ">
               <h5 style="margin-bottom:20px;color:#f12525" v-for="item in featuredUniversities" :key="item.id">{{ item.universityName }}</h5>

             </marquee>
          </v-card>

              <div class="">
                <h2 class="m-4" >Global Study <span style="font-weight:600">Destinations</span></h2>
              </div>
            <v-card @click="onCountry(item)" v-for="item in countries" :key="item.id" elevation="10" :style="{backgroundImage: `url(${item.image})`}" class="tourtheme hvr mb-3">
              <div style="margin:0px;cursor: pointer; ">
                <h4 class="mytxt" style="color:whitesmoke;padding:5px;margin:-10px;border-radius: 0px;margin-top: 125px;">{{ item.countryName }}</h4>
              </div>
            </v-card>

        </div>
      </div>
    </div>
      <v-dialog v-model="dialog" width="500px" persistent>
         <v-card>
           <div style="height:150px;background-color:green;text-align:center;">
             <div style="padding-top:25px;">
                <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
             </div>
           </div>
           <v-container>
             <div style="text-align:center">
                 <h4>Thank You</h4>
                 <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                 <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
             </div>
           </v-container>
         </v-card>
     </v-dialog>
  </v-app>
</template>

<script>
import config from "../../config.json";
import moment from 'moment';
export default {
  components: {
  },
  data() {
    return {
      tab: null,
      valid: true,
      btnSave: false,
      btnSave1: false,
      dialog: false,
      status: false,
      pin: 0,
      otp: false,
      name: [],
      featuredUniversities: [],

      ielts: true,
      toefl: false,
      gre: false,
      sat: false,
      gmat: false,

      details: null,
      image: null,
      banner: null,
      countryId: null,
      countryName: sessionStorage.getItem("countryName"),

      countries: [],
      selectedCountry: null,

      courses: [],
      selectedCourse: null,

      form: {
        name: null,
        email: null,
        mobileNumber: null
      },
      form1: {
        otp: null
      },
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
    };
    
  },
  
   mounted() {
    // this.axios
    //     .get(config.API + `country/author/${this.$route.params.id}`, {
    //       headers: {
    //         Authorization: "bearer " + sessionStorage.getItem("token")
    //       }
    //     })
    //     .then(res => {
    //       let _data = res.data.author;
    //       this.details = _data;
          
    //       if(_data.image!=null) {
    //         this.image = config.API + 'country/files1/' + _data.image;
    //       }
    //       if(_data.banner!=null) {
    //         this.banner = config.API + 'country/files2/' + _data.banner;
    //         console.log(this.banner);
    //       }
    //     })
    //     .catch(() => {
    //       this.$Progress.fail();
    //     });

      this.countryName = sessionStorage.getItem("countryName");
      this.image = sessionStorage.getItem("image");
      this.banner = sessionStorage.getItem("banner");
      this.countryId = sessionStorage.getItem("countryId");
        this.axios
      .get(config.API + `country/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        console.log(list);

        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          if(element.id!=this.countryId) {
            this.countries.push({
            id: element.id,
            countryName: element.countryName.toUpperCase(),
            src: config.API1 + "country/files/" + element.src,
            image: config.API1 + "country/files1/" + element.image
            })
          }
        }

        console.log(this.countries);
      });

      this.axios
    .get(`https://api.worldwin.org/api/Levels`, {
      headers: { Authorization: "Bearer " + sessionStorage.token }
    })
    .then(res => {
      let list = res.data;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        
        this.courses.push(element.levelName)
      }
    });


    this.axios
        .post(
          config.API + `university/search`,
          {
            countryId: this.countryId
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(res => {
          let list = res.data.result;
          console.log(list);

          for (let index = 0; index < list.length; index++) {
            const element = list[index];
            
            this.featuredUniversities.push({
              id: element.id,
              universityName: element.universityName,
              src: config.API1 + "university/files/" + element.src
            })
          }
            })
        .catch(err => {
        });
   },

 methods: {
   blg(item) {
     sessionStorage.setItem("blogTitle", item.title);
     sessionStorage.setItem("blogDescription", item.description);
     sessionStorage.setItem("blogSrc", item.src);
     this.$router.push("/blogDetail/" + item.id );
   },
   getOtp() {
    if (this.$refs.form.validate()) {
      this.btnSave = true;
      this.axios
        .post(
          config.API + `enquiry/author`,
          {
            name: this.form.name,
            email: this.form.email,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            country: this.selectedCountry,
            course: this.selectedCourse,
            page: 'Country Details',
            date: moment().format('MMMM Do YYYY')
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(res => {
          console.log(res);
          this.name = this.form.name.split(' ');
          let firstName = this.name[0];
          let lastName = null;

          if(this.name.length > 2) {
            lastName = this.name[1] + this.name[2]
          }
          else {
            lastName = this.name[1]
          }

          let comment = "Preferred Country: " + this.selectedCountry + ", Preferred Course: " + this.selectedCourse;
          this.axios
        .post(
          `https://api.worldwin.org/api/Leads1`,
          {
            firstName: firstName,
            lastName: lastName,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            cmsId: JSON.parse(res.data.result.id),
            email: this.form.email,
            guardianName: null,
            comment: comment,
            pageName: 'Country Details',
            guardianNo: 0,
            guardianEmail: null,
            relation: null,
            address: null,
            nature: null,
            source: "Website",
            document: false,
            documentType: null,
            notes: null,
            levelId: 0,
            leadDetails: null,
            leadTrainings: null
          },
          {
            headers: {
              Authorization: "bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          this.dialog = true;
          this.btnSave = false;
        })
        .catch(() => {
          this.$toaster.error(`Mobile no is already registered`);
          this.btnSave = false;
        });
        })
        .catch(() => {
          this.$toaster.error("Mobile no is already registered");
          this.btnSave = false;
        });
      }
      /* this.pin = Math.floor(1000 + Math.random() * 9000);
      this.axios
        .post(
          config.API + 'enquiry/otp',
          {
            name: this.form.name,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            otp: this.pin
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(() => {
          this.otp = true;
          this.btnSave = false;
        })
        .catch(() => {
          this.$toaster.error("Mobile number already exists!!");
          this.btnSave = false;
        }); */
    /* } else {
      this.$toaster.error(`Required field are empty!!`);
    } */
  },
  onCountry(item) {
  sessionStorage.setItem("countryName", item.countryName);
  sessionStorage.setItem("image", item.image);
  sessionStorage.setItem("banner", item.banner);
  sessionStorage.setItem("countryId", item.id); 
  ////this.$router.push("/countrydetail/" + item.id );
  if(item.countryName=='UK') {
    this.$router.push("/study-in-uk");
  }
  else if(item.countryName=='DUBAI') {
    this.$router.push("/study-in-dubai");
  }
  else if(item.countryName=='SINGAPORE') {
    this.$router.push("/study-in-singapore");
  }
  else if(item.countryName=='USA') {
    this.$router.push("/study-in-usa");
  }
  else if(item.countryName=='AUSTRALIA') {
    this.$router.push("/study-in-australia");
  }
  else if(item.countryName=='CANADA') {
    this.$router.push("/study-in-canada");
  }
  
 },

    onSubmit() {
      if (this.$refs.form1.validate()) {
        if(this.pin == this.form1.otp) {
          this.btnSave1 = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              country: this.selectedCountry,
              course: this.selectedCourse,
              page: 'Test Preparation',
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }
            this.axios
          .post(
            `http://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.subject),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: null,
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave1 = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave1 = false;
          });
        }
        else {
          this.$toaster.error("Please put a valied OTP");
        }
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    cancel() {
      this.form.name = null;
      this.form.email = null;
      this.form.mobileNumber = null;
      this.otp = false;
      this.dialog = false;
    },
 }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
</style>

<style scoped>
.banner {
  background-image: url('https://www.pexels.com/photo/selective-focus-photo-of-man-using-laptop-1438081/');
  background-size: cover;
  height:200px;
}
.tst {
  border-radius:0px;
  height:300px;
  background-size: cover;
  color: white !important;
    
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
.tourtheme {
  height: 190px;
  margin: 15px;
  background-size: 100%;
  transition: background-size 1s ease-in-out !important;
}
.tourtheme:hover {
  background-size: 120%;
}
.partner {
    margin-top: 15px;
    text-align: center;
    font-size: 23px;
    background-image: linear-gradient(to right, #f19a28 , #f12525);
    border-radius: 0px !important;
    color: whitesmoke !important;
}
.country-heading {
  color:#EC1616;
}
.country p {
  font-weight: 300;
  color:#666666;
  text-align: justify;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
div.scroll { 
                margin:4px, 4px; 
                padding:4px; 
                width: auto; 
                height: 254px; 
                overflow-x: hidden; 
                overflow-x: auto; 
                text-align:justify; 
            }

.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.link:hover {
  cursor: pointer;
  text-decoration: underline;
}
.hvr:hover {
  cursor: pointer;
  border-radius: 5px !important;
  border : 1px solid;
  border-color: black !important;
  transition-duration: 0.7s;
  text-decoration: none !important;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.con {
  margin-top: -100px;
  max-width: 1300px;
}
@media screen and (min-width: 768px){
  .con {
    margin-top: 0px!important;}

  }
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 16%;
  top: 0%;
}
.item {
    border:1px solid !important;
}
</style>
